import React from 'react';
import { useTransactionDetails } from '../hooks/use-transaction-details.js';
import TransactionDetailsPageView from './transaction-details-page-view.jsx';

function TransactionDetailsPageContainer() {
  const state = useTransactionDetails();
  return <TransactionDetailsPageView {...state} />;
}

export default TransactionDetailsPageContainer;
